import routes from "./routes";
import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store'
import { login, userInfo } from '@/api/user';
import kit from '@/../common/js/kit.js';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	fallback: false,
	base: '',
	routes, // short for routes: routes
	scrollBehavior: (to) => {
		if (to.hash) {
			return { selector: to.hash };
		} else {
			return { x: 0, y: 0 };
		}
	},
	linkExactActiveClass: "nav-item active",
});

const whiteUrl = ['^/login$', '^/register$', '/projectGraphView/.*']

// 解决左侧菜单选中问题
router.afterEach((to, from) => {
	let dashboardIdMenu = document.getElementById('dashboardIdMenu');
	if (dashboardIdMenu) {
		if (to.path == '/SimClassDetails' && from.fullPath == "/dashboard") {
			dashboardIdMenu.style.cssText =
				'background-color:#4caf50;box-shadow: 0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2);';
		} else {
			dashboardIdMenu.style.cssText = ''
		}
	}

	let simclassIdMenu = document.getElementById('simclassIdMenu');
	if (simclassIdMenu) {
		if (to.path == '/SimClassDetails' && from.fullPath == "/simclass") {
			let simclassIdMenu = document.getElementById('simclassIdMenu');
			simclassIdMenu.style.cssText =
				'background-color:#4caf50;box-shadow: 0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2);';
		} else {
			simclassIdMenu.style.cssText = ''
		}

	}

	let designIdMenu = document.getElementById('designIdMenu');
	if (designIdMenu) {
		if (to.path == '/designDetail' && from.fullPath == "/design" || to.path == '/newcourse' && from.fullPath == "/design") {
			let designIdMenu = document.getElementById('designIdMenu');
			designIdMenu.style.cssText =
				'background-color:#4caf50;box-shadow: 0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2);';
		} else {
			designIdMenu.style.cssText = ''
		}

	}


    //第三方软件菜单选中问题
	let partySoftware = document.getElementById('partySoftware');
	if (designIdMenu) {
		if (to.path == '/thirdPartySoft/add' && from.fullPath == "/thirdPartySoft") {
			let partySoftware = document.getElementById('partySoftware');
			partySoftware.style.cssText =
				'background-color:#4caf50;box-shadow: 0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2);';
		} else {
			partySoftware.style.cssText = ''
		}

	}
})

router.beforeEach(async (to, from, next) => {
	// if (replaceWechatRedirectUri()) return false;
	const token = localStorage.getItem('token')
	if (token) {
		userInfo().then((res) => {
			if (res.code == '200') {
				kit.setUserInfo(res.data);
				store.commit('permission/SET_PERMISSIONS', res.data.permissions)
				store.commit('permission/SET_USER', res.data.user)
				const userInfoJsonData = localStorage.getItem('USER_INFO');
				if (userInfoJsonData === undefined) {
					next({ path: '/login' })
					return;
				}
				next();
			} else {
				next({ path: '/login' })
			}
		})
	} else if (whiteUrl.some(url => new RegExp(url).test(to.path))) {
		next();
	} else {
		next({ path: '/login' })
	}
});

function getQueryVariable(type) {
	let regExp = new RegExp(`${type}=([^&^#]*)`);
	let l = location.href.match(regExp);
	return l[1] || '';
}
/**
 * 处理微信授权回调redirect_uri
 */
function replaceWechatRedirectUri() {
	let w = location.href.indexOf('?');
	let j = location.href.indexOf('#');
	if (w !== -1 && j > w && getQueryVariable('state')) {
		try {
			let state = getQueryVariable('state');
			let redirect_path = JSON.parse(decodeURIComponent(state)).p;
			let url =
				location.origin +
				'/#/' +
				redirect_path +
				`?code=${getQueryVariable('code')}&state=${state}`;
			location.replace(url);
			return true;
		} catch (e) { }
	}
	return false;
}
export default router;